import { PrintLineView } from "@/components/memo/print/PrintLineView";
import { t } from "@/lib/strings";
import { BRAND } from "@/lib/tokens";
import type { PrintSection } from "@/lib/memoPrint";

/**
 * One printed section (Abschnitt) of a Protokoll: an optional block heading
 * (`number. title`, rendered only when a block is passed), the section's
 * Zwischenüberschrift (with its closure date when retired), then its lines. Purely
 * presentational — no controls.
 */
export function PrintSectionView({
  section,
  blockNumber,
  blockTitle,
}: {
  section: PrintSection;
  blockNumber?: number;
  blockTitle?: string;
}) {
  const showBlock = blockNumber !== undefined && blockTitle !== undefined;

  return (
    <section className="memo-print-section" style={{ marginTop: 18 }}>
      {showBlock ? (
        <h2 className="memo-print-block-heading">
          {blockNumber}. {blockTitle}
        </h2>
      ) : null}

      {section.headingText !== null ? (
        <h3
          className={
            section.headingRetired
              ? "memo-print-subheading memo-print-subheading--retired"
              : "memo-print-subheading"
          }
        >
          {section.headingText}
          {section.headingRetired && section.headingClosedDate ? (
            <span className="memo-print-muted" style={{ fontWeight: 500, color: BRAND.blueGrey }}>
              {` (${t.printClosedPrefix} ${section.headingClosedDate})`}
            </span>
          ) : null}
        </h3>
      ) : null}

      {section.lines.map((line) => (
        <PrintLineView key={line.id} line={line} />
      ))}
    </section>
  );
}
